import ModelMelhousItemServices from "./ModelMelhousItemService";
import readOnlyLayout from "../helpers/readOnlyLayout";

function getView() {
  return readOnlyLayout({
    model: "melhous.service",
    activeSearch: false,
    target: "melhous",
    domain: [],
    fields: {
      title: { type: "char" },
      icon: { type: "char" },
      button: { type: "char" },
      description: { type: "text" },
      item_services: {
        type: "one2many",
        model: "melhous.item_service",
        layout: ModelMelhousItemServices.ctxView(),
      },
    },
    list: [{ name: "title" }, { name: "description" }],
    form: [
      { name: "title" },
      { name: "icon" },
      { name: "button" },
      { name: "description", colSpan: "md:col-span-2" },
      { name: "item_services" },
    ],
  });
}

export default { ctxView: getView };
